(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let images = [], active = new Set(), scheduled = false;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.isIntersecting ? active.add(entry.target) : active.delete(entry.target));
    schedule();
  }, {rootMargin:'10% 0px'});
  function update() {
    scheduled = false;
    if (motion.matches) return;
    const height = innerHeight;
    active.forEach(img => {
      const frame = img.closest('.ar-media,.ar-community-card,.ar-pdp-slide,.ar-hero-media,.ar-about-overlay-media') || img.parentElement;
      const rect = frame.getBoundingClientRect();
      const progress = Math.max(0,Math.min(1,(height-rect.top)/(height+rect.height)));
      img.style.setProperty('--ar-scroll-scale',(1.2-progress*.2).toFixed(4));
    });
  }
  function schedule() {if(!scheduled){scheduled=true;requestAnimationFrame(update);}}
  function refresh() {
    observer.disconnect();active.clear();
    images = [...document.querySelectorAll('#MainContent img')].filter(img => !img.closest('.ar-footer-wordmark'));
    images.forEach(img => {
      img.classList.toggle('ar-scroll-image',!motion.matches);
      if(motion.matches) img.style.removeProperty('--ar-scroll-scale');
      else {img.style.setProperty('--ar-scroll-scale','1.2');observer.observe(img);}
    });
    schedule();
  }
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',refresh);
  motion.addEventListener('change',refresh);
  refresh();
})();

(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  function setup(root) {
    if (instances.has(root)) return;
    const track = root.querySelector('.ar-community-track,.ar-product-grid');
    const controls = root.querySelector('.ar-carousel-controls');
    if (!track || !controls) return;
    const buttons = [...controls.querySelectorAll('[data-direction]')];
    const progress = controls.querySelector('.ar-carousel-progress');
    const controller = new AbortController();
    const {signal} = controller;
    let frame = 0, drag = null, moved = false, suppressClick = false;
    const cards = () => [...track.children];
    const maxScroll = () => Math.max(0,track.scrollWidth-track.clientWidth);
    const positions = () => {
      const first = track.firstElementChild;
      return first ? cards().map(card => Math.min(maxScroll(),card.offsetLeft-first.offsetLeft)) : [0];
    };
    function update() {
      const end = maxScroll();
      const left = Math.max(0,Math.min(end,track.scrollLeft));
      controls.hidden = end < 2;
      buttons.forEach(button => button.disabled = Number(button.dataset.direction)<0 ? left<2 : left>=end-2);
      if(progress) {
        const ratio = Math.min(1,track.clientWidth/track.scrollWidth);
        progress.style.setProperty('--ar-carousel-thumb',`${ratio*100}%`);
        progress.style.setProperty('--ar-carousel-position',`${end ? left/end*(1-ratio)/ratio*100 : 0}%`);
      }
    }
    function slide(target) {
      cancelAnimationFrame(frame);
      const end = Math.max(0,Math.min(maxScroll(),target));
      if (motion.matches) {track.scrollLeft=end;update();return;}
      const start = track.scrollLeft, time = performance.now();
      track.classList.add('is-dragging');
      function tick(now) {
        const t = Math.min(1,(now-time)/500);
        track.scrollLeft=start+(end-start)*(1-Math.pow(1-t,3));
        update();
        if(t<1) frame=requestAnimationFrame(tick);
        else {track.classList.remove('is-dragging');frame=0;}
      }
      frame=requestAnimationFrame(tick);
    }
    function advance(direction) {
      const list=positions();
      const target=direction>0 ? list.find(left=>left>track.scrollLeft+2) : list.reverse().find(left=>left<track.scrollLeft-2);
      slide(target ?? (direction>0 ? maxScroll() : 0));
    }
    buttons.forEach(button=>button.addEventListener('click',()=>advance(Number(button.dataset.direction)),{signal}));
    track.addEventListener('keydown',event=>{
      if(event.target!==track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      if(event.key==='Home' || event.key==='End') slide(event.key==='Home'?0:maxScroll());
      else advance(event.key==='ArrowRight'?1:-1);
    },{signal});
    track.addEventListener('pointerdown',event=>{
      if(event.pointerType!=='mouse' || event.button!==0 || event.target.closest('button,input,select')) return;
      cancelAnimationFrame(frame);track.classList.remove('is-dragging');
      drag={x:event.clientX,y:event.clientY,left:track.scrollLeft,id:event.pointerId};moved=false;suppressClick=false;
    },{signal});
    track.addEventListener('pointermove',event=>{
      if(!drag || event.pointerId!==drag.id) return;
      const delta=event.clientX-drag.x;
      if(!moved && Math.abs(delta)>6 && Math.abs(delta)>Math.abs(event.clientY-drag.y)) {
        moved=true;suppressClick=true;track.classList.add('is-dragging');track.setPointerCapture(event.pointerId);
      }
      if(moved){event.preventDefault();track.scrollLeft=drag.left-delta;update();}
    },{signal});
    function finish(event) {
      if(!drag || event.pointerId!==drag.id) return;
      const wasMoved=moved;drag=null;moved=false;
      if(track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      track.classList.remove('is-dragging');
      if(wasMoved) slide(positions().reduce((a,b)=>Math.abs(a-track.scrollLeft)<Math.abs(b-track.scrollLeft)?a:b));
    }
    window.addEventListener('pointerup',finish,{signal});
    track.addEventListener('pointercancel',finish,{signal});
    track.addEventListener('dragstart',event=>event.preventDefault(),{signal});
    track.addEventListener('click',event=>{
      if(suppressClick){event.preventDefault();event.stopPropagation();suppressClick=false;}
    },{capture:true,signal});
    track.addEventListener('wheel',()=>{cancelAnimationFrame(frame);track.classList.remove('is-dragging');},{passive:true,signal});
    track.addEventListener('touchstart',()=>{cancelAnimationFrame(frame);track.classList.remove('is-dragging');},{passive:true,signal});
    track.addEventListener('scroll',update,{passive:true,signal});
    const observer=new ResizeObserver(update);observer.observe(track);
    instances.set(root,()=>{controller.abort();observer.disconnect();cancelAnimationFrame(frame);});
    update();
  }
  function refresh() {
    instances.forEach((cleanup,root)=>{if(!root.isConnected){cleanup();instances.delete(root);}});
    document.querySelectorAll('.ar-community,.ar-products,.ar-pdp-related').forEach(setup);
  }
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:unload',event=>{
    instances.forEach((cleanup,root)=>{if(event.target.contains(root)){cleanup();instances.delete(root);}});
  });
  refresh();
})();
